module.exports = __webpack_public_path__ + "img/pd-img53.26314ee1.jpg";